var srzsd = srzsd || {};

srzsd.ladeCSS = function(url){

    document.createStyleSheet && !1 ? document.createStyleSheet(url) : $("<link/>").insertAfter($("head link").eq(-1)).attr({
        href: url,
        rel: "stylesheet"
    });

};
